import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import NotificationIcon from "../../../../../styles/img/svg/NotificationIcon";
import CartIcon from "../../../../../styles/img/svg/CartIcon";
import CartIconWhite from "../../../../../styles/img/svg/CartIconWhite";
import NotificationIconWhite from "../../../../../styles/img/svg/NotificationIconWhite";
import { isMobile } from "react-device-detect";
import {
    logoutAuthRequest,
    getUserPointsBalanceRequest,
    homeGetNotificationRequest,
    homeDeleteNotificationRequest,
    homeGetNotificationCountRequest,
    campaignGetRewardAndRecognitionNominationReasonRequest,
} from "../../../../../_redux/_actions";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { kFormatter } from "../../../../../_helpers/support.services";
import LogOutIconDark from "../../../../../styles/img/svg/LogOutIconDark";
import LogOutIconLight from "../../../../../styles/img/svg/LogOutIconWhite";
import {
    getParticipantNotificationRequest,
    readNotificationRequest,
} from "../../../../../_redux/_actions/";
import { Accordion } from "react-bootstrap";
import { UiCol } from "../../../grid-container/GridContainer";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";
import CloseBlackIcon from "../../../../../styles/img/svg/CloseBlackIcon";
import { timeFormatUtcToLocal } from "../../../../../_helpers/support.services";
import { NotificationActive } from "../../../../../styles/img/svg/NotificationActive";
import { DeleteIcon } from "../../../../../styles/img/svg/DeleteIcon";
import { NoticationWhiteActive } from "../../../../../styles/img/svg/NoticationWhiteActive";
import NotificationIconYellow from "../../../../../styles/img/svg/NotificationIconYellow";
import CartIconYellow from "../../../../../styles/img/svg/CartIconYellow";
import UiCropFileUpload from "../../../form/UiCropFileUpload";
import defaultProfilePic from "../../../../../styles/img/default_profile_picture.png";
import { Context } from "../../../../../_context/Store";
import { contextApiActions } from "../../../../../_redux/_constants";

export default function UiTopRightSection(props) {
    const [whiteNotificationIcon, setWhiteNotificationIcon] = useState(false);
    const [whiteCartIcon, setWhiteCartIcon] = useState(false);
    const [notifcation, showNotification] = useState(false);
    const [notifcationId, setNotificationId] = useState();

    const location = useLocation();

    const navigate = useNavigate();
    const actionDispatch = useDispatch();

    const [state, dispatch] = useContext(Context);

    const logOut = (event) => {
        actionDispatch(logoutAuthRequest({ navigate }));
        dispatch({
            type: contextApiActions.SET_REQUESTED_URL,
            payload: "/app/home",
        });
        event.stopPropagation();
        localStorage.removeItem("perfomance-view");
    };

    useEffect(() => {
        actionDispatch(getUserPointsBalanceRequest());
    }, []);

    const {
        auth,
        pointsBalance,
        participantNotifications,
        participantNotificationCount,
        notification,
        notificationCount,
    } = useSelector((state) => {
        return {
            auth: state.auth,
            pointsBalance: state.user.points,
            participantNotifications: state.user.participantNotifications,
            participantNotificationCount:
                state.user.participantNotificationCount,
            notification: state.home.notification,
            notificationCount: state.home.notificationCount,
        };
    });

    // useEffect(() => {
    //     if (auth?.userProfileDetails.id) {
    //         actionDispatch(
    //             getParticipantNotificationRequest({
    //                 id: auth?.userProfileDetails.id,
    //             }),
    //         );
    //     }
    // }, [auth?.userProfileDetails.id, location]);

    const notifcationClose = () => {
        showNotification(false);
    };

    const notificationShow = () => {
        actionDispatch(homeGetNotificationRequest());
        // if (!notifcation) {
        //     actionDispatch(
        //         getParticipantNotificationRequest({
        //             id: auth?.userProfileDetails.id,
        //         }),
        //     );
        // }
        showNotification(!notifcation);
    };

    const readNotification = (notificationId) => {
        actionDispatch(homeDeleteNotificationRequest({ id: notificationId }));
    };

    useEffect(function () {
        window.addEventListener("scroll", () => {
            if (!isMobile) {
                let scrollTop = window.scrollY;
                let activeLink = document.querySelector(
                    ".sb-slider-bottom-line",
                );
                let circle = document.querySelector(".sb-profile-cart-circle");
                let profileName = document.querySelector(".sb-profile-name");
                // if (activeLink !== null) {
                //     if (scrollTop >= activeLink.offsetTop) {
                //         setWhiteCartIcon(true);
                //         setWhiteNotificationIcon(true);
                //         if (circle !== null) {
                //             circle.style.backgroundColor = "#fff";
                //             circle.style.color = "#43454D";
                //         }
                //         if (profileName !== null) {
                //             // profileName.style.color = "#FFF";
                //         }
                //     } else {
                //         setWhiteCartIcon(false);
                //         setWhiteNotificationIcon(false);

                //         if (circle !== null) {
                //             circle.style.backgroundColor = "#FE8E38 ";
                //             circle.style.color = "#fff";
                //         }
                //         if (profileName !== null) {
                //             // profileName.style.color = "#FE8E38";
                //         }
                //     }
                // }
            }
        });
    }, []);

    useEffect(() => {
        actionDispatch(homeGetNotificationCountRequest({}));
        const intervalId = setInterval(() => {
            actionDispatch(homeGetNotificationCountRequest({}));
            actionDispatch(
                campaignGetRewardAndRecognitionNominationReasonRequest({}),
            );
        }, 3000);
        return () => clearInterval(intervalId);
    }, []);

    const gotoMyBasket = () => {
        navigate("/app/shop/my-basket");
    };

    const onSelectNotification = (notificationId) => {
        setNotificationId(notificationId);
    };

    const newRef = useRef(null);
    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });

    const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            showNotification(false);
        }
    };

    return (
        <>
            <div className="sb-top-nav-wr__cart-icon" onClick={gotoMyBasket}>
                {/* <span className="sb-profile-cart-circle">2</span> */}
                <CartIconYellow />
            </div>
            <div
                className="sb-top-nav-wr__notification"
                onClick={notificationShow}
            >
                <>
                    {notificationCount > 0 && (
                        <div className="sb-notification-count-show">
                            {notificationCount}
                        </div>
                    )}
                    {notificationCount.length > 0 ? (
                        <NotificationIconYellow />
                    ) : (
                        <NotificationIconYellow />
                    )}
                </>
            </div>

            <div
                className={
                    notifcation
                        ? "sb-top-notification-wr nt-slide-down"
                        : "sb-top-notification-wr nt-slide-up"
                }
                ref={newRef}
            >
                <div className="sb-top-notification-header">
                    <h4>My notifications </h4>{" "}
                    <span onClick={notifcationClose}>
                        <CloseBlackIcon />
                    </span>
                </div>

                {notification.length > 0 ? (
                    <Accordion onSelect={onSelectNotification}>
                        {notification.map((notification) => {
                            return (
                                <Accordion.Item
                                    eventKey={notification.id}
                                    key={notification.id}
                                >
                                    <UiCol lg="12">
                                        <div
                                            className="sb-first-accordion-header"
                                            style={
                                                notifcationId ===
                                                notification.id
                                                    ? { height: "45px" }
                                                    : {}
                                            }
                                        >
                                            <Accordion.Header>
                                                <div className="sb-heading-top-wr">
                                                    <div className="sb-heading-notification-date">
                                                        <span>
                                                            {" "}
                                                            {timeFormatUtcToLocal(
                                                                notification.displayDate,
                                                                false,
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="sb-heading-wr">
                                                        <h5>
                                                            {notification.title}
                                                        </h5>
                                                        <span>
                                                            {notifcationId !==
                                                            notification.id
                                                                ? notification.body.substring(
                                                                      0,
                                                                      50,
                                                                  )
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                <span className="sb-accordion-wrapper__plus">
                                                    <PlusIcon />
                                                </span>
                                            </Accordion.Header>
                                        </div>
                                        <Accordion.Body>
                                            <div className="sb-notification-left-wr"></div>
                                            <div className="sb-notification-content-wr">
                                                <p>
                                                    {notification.body}
                                                    <span
                                                        onClick={() => {
                                                            navigate(
                                                                `/${notification.url}`,
                                                            );
                                                        }}
                                                    >
                                                        View More
                                                    </span>
                                                </p>
                                            </div>
                                            <div
                                                onClick={() =>
                                                    readNotification(
                                                        notification.id,
                                                    )
                                                }
                                                className="sb-notification-delete-icon"
                                            >
                                                <DeleteIcon />
                                            </div>
                                        </Accordion.Body>
                                    </UiCol>
                                </Accordion.Item>
                            );
                        })}
                    </Accordion>
                ) : (
                    <h6>You have not received any notification</h6>
                )}
            </div>

            <div className="sb-top-nav-wr__profile" onClick={props.showProfile}>
                <div className="sb-top-profile">
                    <div className="sb-top-profile__img">
                        <img
                            src={
                                auth?.userProfileDetails?.profileImageUrl !== ""
                                    ? auth?.userProfileDetails?.profileImageUrl
                                    : defaultProfilePic
                            }
                            alt="profile-img"
                        />
                    </div>

                    <div className="sb-top-profile__right-wr">
                        <div className="sb-top-profile__name">
                            <h5 className="sb-profile-name">
                                {auth?.userProfileDetails.firstName}
                            </h5>
                        </div>
                        <div className="sb-top-profile__points">
                            <h5>{kFormatter(pointsBalance)}</h5>
                            <span>Points</span>
                        </div>
                    </div>
                    <div
                        className="sb-top-profile__logout-icon"
                        onClick={logOut}
                    >
                        <LogOutIconLight />
                    </div>
                </div>
            </div>
        </>
    );
}
